export default __webpack_public_path__ + "static/media/top-up-another-white.4f808118.png";